import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StaffsHelpbuttonDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getStaffs(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonStaffMaintenance/ws_getStaffList', item, options);
  }

  public getStaffsCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/helpButtonStaffMaintenance/count', options);
  }

  public getStaffInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonStaffMaintenance/ws_getStaffDetails', item, options);
  }

  public addNewStaff(context, lang, udid, userImageRaw, active, email, firstname, lastname, password, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { userImageRaw, active, email, firstname, lastname, password, centerInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonStaffMaintenance/ws_saveStaff', item, options);
  }

  public updateStaff(context, lang, udid, internalId, userImageRaw, active, email, firstname, lastname, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, userImageRaw, active, email, firstname, lastname, centerInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonStaffMaintenance/ws_updateStaff', item, options);
  }

  public deleteStaff(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonStaffMaintenance/ws_deleteStaff', item, options);
  }

  public updateImageStaff(context, lang, udid, internalId, imageRaw) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, imageRaw };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonStaffMaintenance/ws_updateImageStaff', item, options);
  }

}
